import React, { useState, useEffect } from "react";
import moment from "moment";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { KeyboardDatePicker } from "@material-ui/pickers";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Grid from "@material-ui/core/Grid";
import Loader from "../../components/Loader";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Box from "@material-ui/core/Box";

import { EQUIPMENT, EQUIPMENT_TYPE } from "../../configs/urls";
import { YES_NO } from "configs/constant";

import { postApi, getApi, putApi } from "../../services/api";
import useForm from "../../formValidator/userForm";

import axios from "axios";
import "./style.css";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "80%",
    margin: "auto",
  },
  formControl: {
    margin: theme.spacing(2, 0),
    minWidth: 120,
    width: "100%",
  },

  selectFullWidth: {
    margin: theme.spacing(2, 0),
    minWidth: "100%",
  },

  marginTop: {
    marginTop: "8% !important",
    width: "100%",
  },
}));

export default function EquipmentOperations(props) {
  const classes = useStyles();
  const [isRequesting, setIsRequesting] = useState(false);
  const [submitButtonText, setSubmitButtonText] = useState("Add Equipment");
  const [equipmentTypeList, setEquipmentTypeList] = useState([]);

  const [selectedStartDate, setStartDate] = useState();
  const [selectedEndDate, setEndDate] = useState();

  const validate = (values) => {
    let errors = {};

    if (!values.product_name) {
      errors.product_name = "Equipment name is required";
    }

    if (!values.product_no) {
      errors.product_no = "Equipment number is required";
    }

    if (!values.equipment_type) {
      errors.equipment_type = "Equipment type is required";
    }

    if (!values.make) {
      errors.make = "make is required";
    }

    if (!values.year) {
      errors.year = "year is required";
    }

    if (!values.ownership) {
      errors.ownership = "Ownership is required";
    }

    if (!values.hours) {
      errors.hours = "Hours is required";
    }

    if (values.ownership == "rented" && !values.owner_name) {
      errors.owner_name = "Owner name is required";
    }

    if (!values.warrent_status) {
      errors.warrent_status = "Do you have warranty?";
    }
    if (
      params?.warrent_status &&
      params?.warrent_status == 1 &&
      !values.warrent_start_date
    ) {
      errors.warrent_start_date = "Select Warranty start date";
    }

    if (
      params?.warrent_status &&
      params?.warrent_status == 1 &&
      !values.warrent_end_date
    ) {
      errors.warrent_end_date = "Select Warranty end date";
    }

    if (
      values.warrent_start_date &&
      values.warrent_start_date > values.warrent_end_date
    ) {
      errors.warrent_end_date = "Select correct dates";
      errors.warrent_start_date = "Select correct dates";
    }

    return errors;
  };

  const saveEquipment = () => {
    if (params.ownership != "rented") {
      delete params.owner_name;
    }

    setIsRequesting(true);
    if (props.match && props.match.params && props.match.params.equipment_id) {
      params.id = props.match.params.equipment_id;
      putApi(EQUIPMENT, params)
        .then(
          (res) => {
            props.history.push("/admin/equipments");
          },
          (err) => {
            console.log(err);
          }
        )
        .finally(() => {
          setIsRequesting(false);
        });
    } else {
      postApi(EQUIPMENT, params)
        .then(
          (res) => {
            props.history.push("/admin/equipments");
          },
          (err) => {
            console.log(err);
          }
        )
        .finally(() => {
          setIsRequesting(false);
        });
    }
  };

  const { params, errors, handleChange, handleSubmit } = useForm(
    saveEquipment,
    validate
  );

  useEffect(() => {
    setIsRequesting(true);

    let equipment = null;
    const equipmentType = getApi(EQUIPMENT_TYPE);
    if (props.match && props.match.params && props.match.params.equipment_id) {
      equipment = getApi(EQUIPMENT + "/" + props.match.params.equipment_id);
      setSubmitButtonText("Update Equipment");
    }

    axios
      .all([equipmentType, equipment])
      .then((res) => {
        if (res[0] && res[0].data) {
          setEquipmentTypeList(res[0].data);

          if (res[0].data[0]) params.equipment_type = res[0].data[0].id;
          params.ownership = "rented";
        }

        if (res[1] && res[1].data) {
          const equipmentData = res[1].data;

          params.product_name = equipmentData.product_name;
          params.product_no = equipmentData.product_no;
          params.equipment_type = equipmentData.equipment_type;
          params.registration_number = equipmentData.registration_number;
          params.make = equipmentData.make;
          params.year = equipmentData.year;
          params.ownership = equipmentData.ownership.toLowerCase();
          params.owner_name = equipmentData.owner_name;
          params.hours = equipmentData.hours;
          params.warrent_status = equipmentData.warrent_status;
          params.warrent_start_date = equipmentData.warrent_start_date;
          params.warrent_end_date = equipmentData.warrent_end_date;
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequesting(false);
      });
  }, []); //eslint-disable-line

  /**
   * @description: selection of start warranty date
   *
   * @param {Object} date
   * @returns
   */
  const handleStartDate = (date, value) => {
    setStartDate(moment(new Date(date)).format("DD/MM/YYYY"));
    params.warrent_start_date = moment(new Date(date)).format("DD/MM/YYYY");
  };

  /**
   * @description: selection of End warranty date
   *
   * @param {Object} date
   * @returns
   */
  const handleEndDate = (date, value) => {
    setEndDate(moment(new Date(date)).format("DD/MM/YYYY"));
    params.warrent_end_date = moment(new Date(date)).format("DD/MM/YYYY");
  };

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <form noValidate onSubmit={handleSubmit}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>{submitButtonText}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel id="equipment-type">
                        Equipment type
                      </InputLabel>
                      <Select
                        labelId="equipment-type"
                        id="equipment-type-simple-select-outlined"
                        name="equipment_type"
                        value={params.equipment_type || 1}
                        onChange={handleChange}
                        label="Equipment type"
                      >
                        {equipmentTypeList.map((type, idx) => (
                          <MenuItem key={idx} value={type.id}>
                            {type.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errors.equipment_type && (
                      <Box color="secondary.main">{errors.equipment_type}</Box>
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="product_name"
                      label="Product Name"
                      name="product_name"
                      autoFocus
                      value={params.product_name || ""}
                      onChange={handleChange}
                    />
                    {errors.product_name && (
                      <Box color="secondary.main">{errors.product_name}</Box>
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="product_no"
                      label="Product number"
                      name="product_no"
                      autoFocus
                      value={params.product_no || ""}
                      onChange={handleChange}
                    />
                    {errors.product_no && (
                      <Box color="secondary.main">{errors.product_no}</Box>
                    )}
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={4}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="make"
                      label="Brand Name"
                      name="make"
                      type="make"
                      value={params.make || ""}
                      onChange={handleChange}
                    />
                    {errors.make && (
                      <Box color="secondary.main">{errors.make}</Box>
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="year"
                      label="Year"
                      name="year"
                      autoFocus
                      value={params.year || ""}
                      onChange={handleChange}
                    />
                    {errors.year && (
                      <Box color="secondary.main">{errors.year}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={4}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      type="number"
                      fullWidth
                      id="hours"
                      label="Hours"
                      name="hours"
                      autoFocus
                      value={params.hours || ""}
                      onChange={handleChange}
                    />
                    {errors.hours && (
                      <Box color="secondary.main">{errors.hours}</Box>
                    )}
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={4} lg={4}>
                    <FormControl
                      variant="outlined"
                      className={classes.selectFullWidth}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Warranty*
                      </InputLabel>

                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        name="warrent_status"
                        value={params.warrent_status}
                        onChange={handleChange}
                        label="Contract Copy"
                      >
                        {Object.values(YES_NO).map(
                          ({ label, value, id }, idx) => {
                            return (
                              <MenuItem
                                key={idx + "-" + id + "-" + value}
                                value={value}
                              >
                                {label}
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                    {errors.warrent_status && (
                      <Box color="secondary.main">{errors.warrent_status}</Box>
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4} lg={4}>
                    <KeyboardDatePicker
                      autoOk
                      required
                      className={classes.marginTop}
                      variant="inline"
                      inputVariant="outlined"
                      label="Warranty Start Date"
                      format="DD/MM/YYYY"
                      disabled={
                        (params.warrent_status && params.warrent_status == 2) ||
                        !params.warrent_status
                      }
                      value={selectedStartDate || params?.warrent_start_date}
                      inputValue={
                        selectedStartDate || params?.warrent_start_date
                      }
                      name="warrent_start_date"
                      InputAdornmentProps={{ position: "start" }}
                      onChange={handleStartDate}
                    />
                    {errors?.warrent_start_date && (
                      <Box color="secondary.main">
                        {errors?.warrent_start_date}
                      </Box>
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4} lg={4}>
                    <KeyboardDatePicker
                      autoOk
                      required
                      className={classes.marginTop}
                      variant="inline"
                      inputVariant="outlined"
                      label="Warranty End Date"
                      disabled={
                        (params.warrent_status && params.warrent_status == 2) ||
                        !params.warrent_status
                      }
                      format="DD/MM/YYYY"
                      value={selectedEndDate || params?.warrent_end_date}
                      inputValue={selectedEndDate || params?.warrent_end_date}
                      name="warrent_end_date"
                      InputAdornmentProps={{ position: "start" }}
                      onChange={handleEndDate}
                    />
                    {errors?.warrent_end_date && (
                      <Box color="secondary.main">
                        {errors?.warrent_end_date}
                      </Box>
                    )}
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6} lg={6}>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Ownership
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        name="ownership"
                        value={params.ownership || "owned"}
                        onChange={handleChange}
                        label="Ownership"
                      >
                        <MenuItem value="owned">Owned</MenuItem>
                        <MenuItem value="rented">Rented</MenuItem>
                      </Select>
                    </FormControl>
                    {errors.ownership && (
                      <Box color="secondary.main">{errors.ownership}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6} lg={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="owner_name"
                      label="Owner Name"
                      name="owner_name"
                      type="owner_name"
                      value={params.owner_name || ""}
                      onChange={handleChange}
                      disabled={params.ownership !== "rented"}
                    />
                    {errors.owner_name && (
                      <Box color="secondary.main">{errors.owner_name}</Box>
                    )}
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                <Grid
                  container
                  direction="row"
                  justify="flex-end"
                  alignItems="center"
                >
                  <Button color="primary" type="submit">
                    {submitButtonText}
                  </Button>
                </Grid>
              </CardFooter>
            </Card>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}
